// "Tamanho do texto" do app (0.67, texto 05 D3): Pequeno / Médio / Grande.
// O Metro (metro.config.js) faz o código do app importar o react-native por aqui: tudo é o mesmo react-native,
// só o Text e o TextInput aumentam ou diminuem a letra conforme a escolha. Os pacotes de fora não mudam.
// 0.67 (Modo discreto): o Text da tela também troca os valores em dinheiro por "R$ •••".
// 0.67.1: este arquivo fica SOZINHO na pasta lib/rn. O Metro guarda a resolução do "react-native" por pasta;
// sozinho aqui, ele sempre recebe o react-native de verdade (antes, no Windows, podia receber a si mesmo e
// nenhum texto aparecia). O react-native vem PRIMEIRO, antes do discreto, para não haver ciclo pela metade.
export * from 'react-native';
import { StyleSheet, Text as RNText, TextInput as RNTextInput } from 'react-native';
import { Children, createContext, useContext, useSyncExternalStore } from 'react';
import { discretoAtivo, mascarar, ouvirDiscreto, versaoDiscreto } from '../discreto';

let escala = 1;
/** 'p' = 0,9 · 'm' = 1 · 'g' = 1,15 (o app remonta a tela ao trocar). */
export function definirEscalaTexto(tam?: 'p' | 'm' | 'g' | null) { escala = tam === 'p' ? 0.9 : tam === 'g' ? 1.15 : 1; }
export const escalaTexto = () => escala;

const DentroDeTexto = createContext(false);
const PADRAO = 14;   // tamanho padrão do Text e do TextInput no React Native

function maior(style: any, dentro: boolean) {
  const st = (StyleSheet.flatten(style) ?? {}) as { fontSize?: number; lineHeight?: number };
  const extra: { fontSize?: number; lineHeight?: number } = {};
  if (typeof st.fontSize === 'number') extra.fontSize = st.fontSize * escala;
  else if (!dentro) extra.fontSize = PADRAO * escala;          // texto dentro de outro herda a letra do de fora
  if (typeof st.lineHeight === 'number') extra.lineHeight = st.lineHeight * escala;
  return extra;
}

function TextoEscalado(props: any) {
  const dentro = useContext(DentroDeTexto);
  useSyncExternalStore(ouvirDiscreto, versaoDiscreto);
  let p = props;
  if (discretoAtivo() && props.children != null) {
    const filhos = Children.map(props.children, (c: any) => (typeof c === 'string' ? mascarar(c) : c));
    p = { ...props, children: filhos };
  }
  if (escala === 1) return <RNText {...p} />;
  return <DentroDeTexto.Provider value><RNText {...p} style={[props.style, maior(props.style, dentro)]} /></DentroDeTexto.Provider>;
}
function CampoEscalado(props: any) {
  if (escala === 1) return <RNTextInput {...props} />;
  return <RNTextInput {...props} style={[props.style, maior(props.style, false)]} />;
}
export const Text = TextoEscalado as unknown as typeof RNText;
export const TextInput = CampoEscalado as unknown as typeof RNTextInput;
